export default {
      id: "status_violations-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.svg#status_violations",
      toString: function () {
        return this.url;
      }
    }